import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { isInNativeTab, notifyLocationChanged } from '../../utils/nativeTab';

const ROUTE_NAMES: Record<string, string> = {
  '/dashboard': 'Dashboard',
  '/users': 'Users',
  '/feed': 'Feed',
  '/migration': 'Migration',
  '/logs': 'Logs',
  '/profile': 'Profile',
  '/settings': 'Settings',
};

const LocationReporter: React.FC = () => {
  const location = useLocation();
  useEffect(() => {
    if (!isInNativeTab()) return;
    const featureName = ROUTE_NAMES[location.pathname] || 'Evo';
    notifyLocationChanged(window.location.href, featureName);
  }, [location.pathname, location.search]);
  return null;
};

export default LocationReporter;
